import React from 'react';
import GearIconUrl from '@assets/icons/certificates/steps/gear.svg';
import WalletIconUrl from '@assets/icons/certificates/steps/wallet.svg';
import CalendarIconUrl from '@assets/icons/certificates/steps/calendar.svg';
import LockIconUrl from '@assets/icons/certificates/travel/lock.svg';
import CalendarCancelledIconUrl from '@assets/icons/certificates/travel/calendar-cancel.svg';
import LocationIconUrl from '@assets/icons/certificates/travel/location.svg';
import ShieldIconUrl from '@assets/icons/certificates/travel/shield.svg';
import ClocksIconUrl from '@assets/icons/certificates/travel/clocks.svg';
import ClockIconUrl from '@assets/icons/certificates/travel/clock.svg';

function iconImg(src: string, alt = ''): React.ReactElement {
  return <img src={src} alt={alt} aria-hidden />;
}

export const LANDING_PAGE_SIZE = 6;

export const STEPS = [
  {
    icon: iconImg(GearIconUrl),
    stepNumber: 1,
    titleId: 'certificates.landing.step1.title',
    descriptionId: 'certificates.landing.step1.description',
  },
  {
    icon: iconImg(WalletIconUrl),
    stepNumber: 2,
    titleId: 'certificates.landing.step2.title',
    descriptionId: 'certificates.landing.step2.description',
  },
  {
    icon: iconImg(CalendarIconUrl),
    stepNumber: 3,
    titleId: 'certificates.landing.step3.title',
    descriptionId: 'certificates.landing.step3.description',
  },
] as const;

export const HOW_IT_WORKS_ITEMS = [
  {
    icon: iconImg(LockIconUrl),
    titleId: 'certificates.landing.howItWorks.lock.title',
    descriptionId: 'certificates.landing.howItWorks.lock.description',
  },
  {
    icon: iconImg(CalendarCancelledIconUrl),
    titleId: 'certificates.landing.howItWorks.ready.title',
    descriptionId: 'certificates.landing.howItWorks.ready.description',
  },
  {
    icon: iconImg(LocationIconUrl),
    titleId: 'certificates.landing.howItWorks.selection.title',
    descriptionId: 'certificates.landing.howItWorks.selection.description',
  },
  {
    icon: iconImg(ShieldIconUrl),
    titleId: 'certificates.landing.howItWorks.simple.title',
    descriptionId: 'certificates.landing.howItWorks.simple.description',
  },
  {
    icon: iconImg(ClocksIconUrl),
    titleId: 'certificates.landing.howItWorks.pricing.title',
    descriptionId: 'certificates.landing.howItWorks.pricing.description',
  },
  {
    icon: iconImg(ClockIconUrl),
    titleId: 'certificates.landing.howItWorks.choice.title',
    descriptionId: 'certificates.landing.howItWorks.choice.description',
  },
] as const;
